import React from "react";
import { BaseIcon, BaseIconProps } from "./baseIcon";

export const PopupUnionIcon = (props: BaseIconProps) => {
  return (
    <BaseIcon {...props} viewBox="0 0 78 35">
      <path
        d="M39 0C44.2354 0 49.0005 0.889223 52.5654 3H78C69.0165 3 61.4172 8.92325 58.8926 17.0771C57.8535 27.1467 49.3443 35 39 35C28.6557 35 20.1455 27.1468 19.1064 17.0771C16.5817 8.92339 8.98344 3 0 3H25.4346C28.9995 0.889223 33.7646 0 39 0Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};
